import { SuborderLoadCarriersTable } from "@/components/stock/suborder-load-carriers-table";
import type { SuborderPanelBaseProps } from "../../shared";

/**
 * The carriers this round sends along: the boxes and pallets its goods travel in, and the empties
 * the order asked for as Leergut, which are the same pallets rather than a second pile.
 *
 * A round whose order owes only Leergut has no article lines at all, so this is where its whole
 * work sits — which is why it is a panel of its own beside the articles rather than a column in
 * them.
 */
export function SuborderLoadCarriers({ orderId, suborderId }: SuborderPanelBaseProps) {
	/** Render */
	return (
		<SuborderLoadCarriersTable
			orderId={orderId}
			suborderId={suborderId}
			variant="table"
		/>
	);
}
